<template>
  <div class="coin-flow-management">
    <el-card shadow="never" class="animate__animated animate__fadeInUp">
      <div class="filter-card">
        <div class="filter-bar">
          <div class="filter-group">
            <el-input
              v-model="searchUsername"
              placeholder="搜索手机号"
              prefix-icon="el-icon-search"
              clearable
              class="filter-input"
              @keyup.enter.native="handleSearch"
            />
            <el-date-picker
              v-model="dateRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :default-time="['00:00:00', '23:59:59']"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              class="filter-daterange"
              @change="handleSearch"
            />
            <date-range-quick v-model="dateRange" @change="handleSearch" />
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
            <el-button icon="el-icon-refresh" @click="refreshList">重置</el-button>
          </div>
        </div>
      </div>

      <div v-if="error" class="error">{{ error }}</div>

      <el-table
        v-else
        :data="list"
        border
        stripe
        v-loading="loading"
        element-loading-text="正在加载..."
        class="animate__animated animate__fadeIn"
        row-key="id"
      >
        <el-table-column prop="id" label="ID" width="80" align="center" />
        <el-table-column prop="username" label="手机号" min-width="200" show-overflow-tooltip />
        <el-table-column prop="coinAmount" label="金币数量" width="120" align="center">
          <template slot-scope="scope">
            {{ scope.row.coinAmount != null ? scope.row.coinAmount : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="flowType" label="流水类型" width="140" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.flowType === 'user_reward'" type="success" size="small">用户观看奖励</el-tag>
            <el-tag v-else-if="scope.row.flowType === 'withdraw'" type="primary" size="small">金币提现</el-tag>
            <el-tag v-else-if="scope.row.flowType === 'checkin'" type="success" size="small">签到</el-tag>
            <el-tag v-else-if="scope.row.flowType === 'red_packet_streak'" type="warning" size="small">红包连签</el-tag>
            <el-tag v-else-if="scope.row.flowType === 'withdraw_refund'" type="danger" size="small">提现退还</el-tag>
            <el-tag v-else-if="scope.row.flowType === 'platform'" type="info" size="small">平台</el-tag>
            <span v-else>{{ scope.row.flowType }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="描述" min-width="220" show-overflow-tooltip />
        <el-table-column prop="createdTime" label="时间" width="180" align="center" show-overflow-tooltip />
      </el-table>

      <div v-if="!error && !loading && list.length === 0" class="empty-state">
        <el-empty :description="searchUsername || (dateRange && dateRange.length) ? '没有符合条件的记录' : '暂无金币流水数据'" />
      </div>

      <div v-if="pagination.total > 0" class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.page"
          :page-size="pagination.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="pagination.total"
          @current-change="handlePageChange"
          @size-change="handleSizeChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { get } from '@/utils/http'
import { getDefaultDateRange } from '@/utils/dateRange'
import DateRangeQuick from '@/components/DateRangeQuick.vue'

export default {
  name: 'CoinFlowManagement',
  components: { DateRangeQuick },
  data() {
    return {
      list: [],
      loading: false,
      error: '',
      searchUsername: '',
      dateRange: getDefaultDateRange(),
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    async fetchList() {
      this.loading = true
      this.error = ''
      try {
        const params = {
          page: this.pagination.page,
          pageSize: this.pagination.pageSize
        }
        if (this.searchUsername) {
          params.username = this.searchUsername
        }
        const [start, end] = this.dateRange || []
        if (start) params.startDate = start
        if (end) params.endDate = end
        const result = await get('/admin/coin-flow', params)
        const data = result.data || {}
        this.list = Array.isArray(data.records) ? data.records : []
        this.pagination.total = data.total || 0
        this.pagination.page = data.page || this.pagination.page
        this.pagination.pageSize = data.pageSize || this.pagination.pageSize
      } catch (e) {
        this.error = e && e.message ? e.message : '获取金币流水失败'
        this.list = []
        this.pagination.total = 0
      } finally {
        this.loading = false
      }
    },

    handleSearch() {
      this.pagination.page = 1
      this.fetchList()
    },

    handlePageChange(page) {
      this.pagination.page = page
      this.fetchList()
    },

    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.page = 1
      this.fetchList()
    },

    refreshList() {
      this.searchUsername = ''
      this.dateRange = getDefaultDateRange()
      this.pagination.page = 1
      this.fetchList()
    }
  }
}
</script>

<style scoped>
.filter-card {
  margin-bottom: 20px;
}
.filter-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}
.filter-input {
  width: 180px;
}
.filter-daterange {
  width: 380px;
}

.error {
  color: #f87171;
  padding: 10px;
  background-color: rgba(239, 68, 68, 0.15);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: 4px;
  margin-bottom: 20px;
}

.empty-state {
  text-align: center;
  padding: 40px 0;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
</style>
